import { SunClockOutlineIcon } from './SunClockOutlineIcon';

/**
 * author: Hans Böhm
 * id 39AB9880-94EC-44BF-96FC-D5ACA1AA3356
 * name sun-clock-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sun-clock-outline.svg
 * tags
 * - Weather 
 * - Home Automation 
 * - Date / Time 
 */
export const SunScheduleOutlineIcon = SunClockOutlineIcon;
export default SunScheduleOutlineIcon